import React from "react";
export default function PreviousIcon() {
    return (
        <svg  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="currentColor"/>
        </svg>
    );
}